import React, { Component } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../common/classes/entityComposition';
import { makeOrganizationTree } from './assetSelectors';
import TieredSelect from '../common/lookups/tieredSelect';
import searchFactory from '../common/lookups/searchFactory';
import Loader from '../common/loader';
const OrgSearch = searchFactory('associatedAssetOrganization');
class AssetOrganizationFilter extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    const {
      associatedAssetOrganization: {
        indexQuery
      },
      associatedAssetOrganizationActions: {
        serverFilter
      },
      filters
    } = this.props;
    serverFilter(filters, indexQuery);
  }
  handleChange(selectedValues, newValue) {
    const {
      filters,
      onFilter,
      onAdd
    } = this.props;
    const filterName = newValue.entity;
    if (filterName === 'organization' || filterName === 'facility' || filterName === 'facilityGroup' || filterName === 'facilityGroupArea') {
      let currentFilters = filters[filterName] ? filters[filterName] : [];
      if (currentFilters.some(at => at.id === newValue.id)) {
        // remove this from the list
        currentFilters = currentFilters.filter(at => at.id !== newValue.id);
      } else {
        const newFilter = {
          id: newValue.id,
          name: newValue.name
        };
        currentFilters = [newFilter];
      }
      onFilter(filterName, currentFilters);
    } else if (filterName === 'asset') {
      onAdd(newValue);
    }
  }
  render() {
    const {
      assetsLoading,
      filters,
      orgOptions,
      onBack,
      associatedAssetOrganization: {
        loading: orgsLoading
      }
    } = this.props;
    let selections = [];
    if (filters) {
      if (filters.organization) {
        selections = filters.organization;
      }
      if (filters.facility) {
        selections = selections.concat(filters.facility);
      }
      if (filters.facilityGroup) {
        selections = selections.concat(filters.facilityGroup);
      }
      if (filters.facilityGroupArea) {
        selections = selections.concat(filters.facilityGroupArea);
      }
    }
    return /*#__PURE__*/React.createElement(TieredSelect, {
      style: {
        minHeight: 100
      },
      label: "Organizations",
      data: orgOptions,
      value: selections,
      onBack: onBack,
      onChange: this.handleChange,
      backLabel: "Back",
      multi: false
    }, /*#__PURE__*/React.createElement(OrgSearch, null), assetsLoading || orgsLoading ? /*#__PURE__*/React.createElement(Loader, {
      style: {
        margin: '20px auto',
        fontSize: '5px'
      }
    }) : null);
  }
}
AssetOrganizationFilter.defaultProps = {
  filters: {}
};
AssetOrganizationFilter.propTypes = {
  assetsLoading: PropTypes.bool.isRequired,
  filters: PropTypes.shape({
    organization: PropTypes.arrayOf(PropTypes.shape({})),
    facility: PropTypes.arrayOf(PropTypes.shape({})),
    facilityGroup: PropTypes.arrayOf(PropTypes.shape({})),
    facilityGroupArea: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  associatedAssetOrganization: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})),
    loading: PropTypes.bool
  }).isRequired,
  associatedAssetOrganizationActions: PropTypes.shape({
    serverFilter: PropTypes.func,
    serverIndex: PropTypes.func
  }).isRequired,
  orgOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onFilter: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired
};
export { AssetOrganizationFilter as TestAssetOrganizationFilter };
export default entityComposition(AssetOrganizationFilter, ['associatedAssetOrganization'], {
  orgOptions: state => makeOrganizationTree(state.associatedAssetOrganization.list, state.associatedAsset.list)
});